import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Box, Button, Theme, useMediaQuery } from "@mui/material";
import { ActionIconButton, ResponsiveDropdown } from "@components";
import AddIcon from "@icons/myicons/plus.svg?react";
import DotsIcon from "@icons/myicons/dots.svg?react";
import { useSingleSecurityMenuItems } from "./useSingleSecurityMenuItems";

interface Props {
  quoteProvider: string;
  tickerSymbol: string;
  hasWatchlists: boolean;
  onAddToWatchlist: () => void;
}

export const SingleSecurityPageActions = ({
  quoteProvider,
  tickerSymbol,
  hasWatchlists,
  onAddToWatchlist,
}: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const onAddToDepot = () =>
    navigate(
      `/new-transaction-wizard?quoteProvider=${quoteProvider}&tickerSymbol=${tickerSymbol}`
    );

  const menuItems = useSingleSecurityMenuItems({
    hasWatchlists,
    onAddToDepot,
    onAddToWatchlist,
  });

  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
      {!isSm && (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          startIcon={<AddIcon width="18px" height="12px" />}
          onClick={onAddToDepot}
        >
          {t("addToDepot")}
        </Button>
      )}
      <ResponsiveDropdown
        id="single-security-actions-menu"
        items={menuItems}
        anchor={
          <ActionIconButton
            data-testid="open-menu-button"
            color="tertiary"
            size="small"
          >
            <DotsIcon />
          </ActionIconButton>
        }
      />
    </Box>
  );
};
